import type { AppState } from '@store/types'

export const selectTemplates = (state: AppState) => state.templates

export const selectTemplateSaveError = (state: AppState) =>
  state.templates.saveError
